import { render, staticRenderFns } from "./PostEditor.vue?vue&type=template&id=0126c484&"
import script from "./PostEditor.vue?vue&type=script&lang=js&"
export * from "./PostEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports